// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global Plyr, google, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }

            wntrTheme.body.find('input.datepicker').attr('autocomplete', 'off');
        },

        /**
         * Check if mouse is used
         */
        __checkIfMouseIsUsed: () => {
            // Let the document know when the mouse is being used
            document.body.addEventListener('mousedown', function() {
                document.body.classList.add('using-mouse');
            });
            // Re-enable focus styling when Tab is pressed
            document.body.addEventListener('keydown', function(event) {
                if(event.keyCode === 9) {
                    document.body.classList.remove('using-mouse');
                }
            });
        },

        /**
        * Init accordions
        */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length > 0) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }

            if(wntrTheme.body.find('.handorgel--sub').length > 0) {
                $.each(wntrTheme.body.find('.handorgel--sub'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
        * Toggle mobile sidebar
        */
        __toggleMobileSidebar: function() {
            const toggle_sidebar = wntrTheme.body.find('.sidebar-nav-mobile-title');

            toggle_sidebar.on('click', function() {
                $(this).toggleClass('is-active');

                wntrTheme.body.find('.sidebar-inner').slideToggle('fast');
            });
        },

        /**
        * Scroll to form after successful playment
        */
        __scrollToFromAfterSuccessfulPayment: function() {
            const gf_stripe_success = getUrlParameter('gf_stripe_success');
            const gf_stripe_session_id = getUrlParameter('gf_stripe_session_id');

            if((gf_stripe_success && gf_stripe_success.length > 0) && (gf_stripe_session_id && gf_stripe_session_id.length > 0)) {
                const form = wntrTheme.body.find('.page-section-form').first();

                $('html,body').animate({
                    scrollTop: form.offset().top
                }, 200);
            }

            function getUrlParameter(sParam) {
                const sPageURL = window.location.search.substring(1);
                const sURLVariables = sPageURL.split('&');
                let sParameterName;
                let i;

                for(i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');

                    if(sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                    }
                }
            }
        },

        /**
         * Init plyr
         */
        __initPlyr: function() {
            const players = wntrTheme.body.find('.plyr-player');
            players.each(function() {
                new Plyr($(this)[0]);
            });
        },

        /**
         * Toggle sidebar children
         */
        __toggleSidebarChildren: function() {
            const toggle_children_btn = wntrTheme.body.find('.toggle-child');
            let can_toggle = true;

            if(toggle_children_btn.length > 0 && can_toggle) {
                toggle_children_btn.on('click', function(e) {
                    can_toggle = false;
                    e.preventDefault();

                    const el = $(this);
                    const children = el.closest('a').next();

                    if(children.is(':visible')) {
                        el.css('transform', 'rotate(-90deg)');
                    } else {
                        el.css('transform', 'rotate(90deg)');
                    }

                    children.slideToggle('fast', function() {
                        can_toggle = true;
                    });
                });
            }
        },

        /**
         * Init gmaps google map
         */
        __initGoogleMaps: function() {
            const map_div = wntrTheme.body.find('.google-map');

            if(map_div.length > 0) {
                const locations = [];
                locations.push([
                    map_div.data('address'),
                    map_div.data('lat'),
                    map_div.data('lng')
                ]);

                let zoom;
                let showDefaultUi;

                // if mobile
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    zoom = 14;
                    showDefaultUi = true;

                    // if NOT mobile
                } else {
                    zoom = 15;
                    showDefaultUi = false;
                }

                const map = new google.maps.Map(document.getElementById('google-map'), {
                    zoom: zoom,
                    disableDefaultUI: showDefaultUi,
                    center: new google.maps.LatLng(locations[0][1], locations[0][2]),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    styles: [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e9e9e9"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dedede"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        }
                    ]
                });

                const infowindow = new google.maps.InfoWindow();

                let marker;
                let i;

                for(i = 0; i < locations.length; i++) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                        map: map
                    });

                    google.maps.event.addListener(marker, 'click', (function(marker, i) {
                        return function() {
                            infowindow.setContent(
                                '<div class="gmaps-marker-info">' +
                                '<h3 class="google-title small-title">' + locations[i][0] + '</h3>' +
                                '</div>');
                            infowindow.open(map, marker);
                        };
                    })(marker, i));
                }

                google.maps.event.trigger(map, 'resize');
                //$('#image-gmaps').find('div:first-child').first().css('overflow', 'hidden');
            }
        },

        // FancyBox settings
        __fancyBoxSettings: function() {
            wntrTheme.body.find('[data-fancybox]').fancybox({
                animationEffect: 'fade',
                touch: false
            });
        },


        __initSlickCarousel: function() {
            wntrTheme.body.find('.text-carousel').slick({
                infinite: true,
                dots: true,
                arrows: false,
            }).on('setPosition', function(event, slick) {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            });
        },

        /**
         * Scroll to top
         */
        __scrollToTop: function() {
            wntrTheme.body.find('.sticky-to-top').on('click', function() {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            });
        },

        /**
         * Toggle menu
         */
        __toggleMenu: function() {
            const menu_btn = wntrTheme.body.find('.hamburger');
            const sub_menu_btn = wntrTheme.body.find('.toggle-submenu-button');

            menu_btn.on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.navigation').slideToggle('fast');
            });

            sub_menu_btn.on('click', function() {
                $(this).find('.closed, .open').toggle();
                $(this).next().slideToggle();
            });

            wntrTheme.body.find('.main-menu-container .menu-item-has-children, .main-menu-container .sub-menu').on('mouseover', function() {
                $(this).find('.sub-menu').addClass('sub-menu-active');
            });

            wntrTheme.body.find('.main-menu-container .menu-item-has-children').on('mouseout', function() {
                $(this).find('.sub-menu').removeClass('sub-menu-active');
            });

            wntrTheme.body.find('.main-menu-container .sub-menu').on('mouseout', function() {
                const parent = $(this).closest('.menu-item-has-children');
                parent.removeClass('sub-menu-active');
                parent.find('.sub-menu').removeClass('sub-menu-active');
            });

            if(!wntrTheme.body.hasClass('using-mouse')) {
                wntrTheme.body.find('#main-menu > .menu-item > a').on('focus', function() {
                    const $menu_item = $(this).closest('.menu-item');

                    if($menu_item.hasClass('menu-item-has-children')) {
                        $menu_item.find('.sub-menu').addClass('sub-menu-active');
                    } else {
                        $('.sub-menu').removeClass('sub-menu-active');
                    }
                });
            }

            $(document).keyup(function(e) {
                if(e.keyCode === 27) {
                    $('.sub-menu').removeClass('sub-menu-active');
                    $('.navigation').hide();
                }
            });
        },

        /**
         * Toggle search
         */
        __toggleSearch: function() {
            const menu_btn = wntrTheme.body.find('.header-toggle-search');
            const header_search_form = wntrTheme.body.find('.header-search-form');

            menu_btn.on('click', function() {
                if($(window).width < 1300) {
                    header_search_form.slideToggle('fast');
                } else {
                    header_search_form.toggle(0);
                }

                header_search_form.find('input').focus();
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && header_search_form.is(':visible')) {
                    header_search_form.hide();
                }
            });
        },

        /**
         * Toggle sidebar puffs
         */
        __toggleSideBarPuffs: function() {
            const puff_title = wntrTheme.body.find('.sidebar-puff-title');

            puff_title.on('click', function() {
                $(this).closest('.sidebar-puff').find('.sidebar-buff-inner').toggle();
                $(this).toggleClass('puff-visible');
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);